export const config = {
  title: "Guerrero Landscaping LLC | Mount Vernon, WA",
  meta: {
    description:
      "Guerrero Landscaping LLC offers professional landscaping and lawn care services in Mount Vernon, WA. Quality outdoor solutions for residential and commercial properties.",
    keywords: [
      "Guerrero Landscaping",
      "Mount Vernon WA landscaping",
      "lawn care Mount Vernon",
      "landscape maintenance",
      "yard cleanup services"
    ],
    author: "Guerrero Landscaping LLC",
    canonicalUrl: "https://guerrerolandscapingllc.com/",
  },
  sections: {
    header: {
      businessName: "Guerrero Landscaping LLC",
    },
    sectionB: {
      heroTitle: "Guerrero Landscaping LLC",
      heroSubtitle: "Transforming outdoor spaces across Mount Vernon, WA",
      learnAboutText: "Request a Free Quote",
      phoneNumber: "3606105072",
      phoneLabel: "(360) 610-5072",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1324918160/photo/professional-gardener-trimming-hedge.jpg?s=612x612&w=0&k=20&c=zumBbqam7P2pNpoGMrca4RhZGWW7zfRDUDE2zqABJTs=",
      cardData: [
        {
          title: "Landscaping",
          description: "From design to execution, we make your outdoor vision a reality.",
        },
        {
          title: "Lawn Maintenance",
          description: "Regular mowing, trimming, and seasonal care for a healthy lawn.",
        },
        {
          title: "Clean-up Services",
          description: "Thorough yard clean-up services including debris and leaf removal.",
        },
      ],
      description:
        "Guerrero Landscaping LLC is a trusted provider of outdoor landscaping and lawn care services in Mount Vernon and nearby areas. We prioritize quality, reliability, and customer satisfaction.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We deliver reliable, timely, and professional landscaping solutions to enhance your property's curb appeal.",
      cards: [
        {
          title: "Landscape Design",
          description: "Creative landscape planning tailored to your property and taste.",
          imageSrc: "https://media.istockphoto.com/id/2165553766/photo/young-hispanic-latino-man-using-a-hand-shovel-to-dig-holes-in-soil-for-a-flowerbed-in-a.jpg?s=612x612&w=0&k=20&c=kBzVQvpnzk_rxQgh9s1ae0579ibheY3uEIEj3OLLCbc=",
          imageAlt: "Landscape Design",
        },
        {
          title: "Mowing & Edging",
          description: "Keep your yard clean and trimmed with precision cutting.",
          imageSrc: "https://media.istockphoto.com/id/2179605941/photo/mowing-or-cutting-the-very-long-grass-with-a-green-lawn-mower-in-the-summer-sun.jpg?s=612x612&w=0&k=20&c=Nt46k_SkCEqN5dB2e7L77_gmzOm26BfIIT10wL_xdLI=",
          imageAlt: "Mowing and Edging",
        },
        {
          title: "Spring & Fall Clean-up",
          description: "Seasonal clean-up services to keep your yard fresh and debris-free.",
          imageSrc: "https://media.istockphoto.com/id/1347784849/photo/scenic-view-of-a-beautiful-landscape-garden-with-a-green-mowed-lawn.jpg?s=612x612&w=0&k=20&c=VU6cE_762lTNwqFeuc1A-JFksy6HcXM35Xq3ox3-Az0=",
          imageAlt: "Yard Cleanup",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Family-Owned & Operated",
        "Free Estimates",
        "Satisfaction Guaranteed",
        "Affordable Pricing",
        "Fully Insured"
      ],
    },
    sectionD: {
      aboutTitle: "About Guerrero Landscaping LLC",
      aboutImage: {
        src: "https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/galleryClientes%2F9edb81c3-2090-4d33-b122-06338c2a3a33%2FfotosCliente%2F11%20(11)-5314.webp?alt=media&token=76696a01-b86b-4bb5-9e4b-3714fab12e47",
        alt: "Guerrero Landscaping Logo",
      },
      aboutText: [
        "Founded with a passion for nature and aesthetics, Guerrero Landscaping LLC brings over a decade of experience in outdoor care and beautification.",
        "Our skilled team delivers professional landscaping and lawn maintenance services to residential and commercial clients in Mount Vernon, WA."
      ],
    },
    sectionE: {
      profileImage: "https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Clientes%2F9edb81c3-2090-4d33-b122-06338c2a3a33%2F9edb81c3-2090-4d33-b122-06338c2a3a33_whiteLogo.webp?alt=media&token=84d6ea8b-6efb-4f54-a896-5928a4bc6539",
      profileAlt: "Guerrero Landscaping LLC Logo",
      businessName: "Guerrero Landscaping LLC",
      contact: {
        phone: "3606105072",
        phoneLabel: "(360) 610-5072",
        email: "estradasilvestre19@gmail.com",
        website: "https://guerrerolandscapingllc.com/",
        address: "Mount Vernon, WA, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Mount Vernon, WA, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26878.547688134937!2d-122.3499!3d48.4191!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548565a3db89ddbb%3A0x2c347c0192152b60!2sMount%20Vernon%2C%20WA!5e0!3m2!1sen!2sus!4v1699961000000",
    },
  },
};

export default config;
